module.exports = __webpack_public_path__ + "static/media/da-vincis-treasure.7e75df57.gif";